module.exports = __webpack_public_path__ + "img/8.80f072e1.jpg";